export type SectionSizeComparisonTone = 'average' | 'above' | 'below';

export interface SectionSizeComparison {
  value: number;
  average: number;
  percentDifference: number | null;
  tone: SectionSizeComparisonTone;
  barRatio: number;
}

export function computeAverage(values: number[]): number {
  if (values.length === 0) {
    return 0;
  }
  const total = values.reduce((sum, value) => sum + value, 0);
  return total / values.length;
}

export function compareSectionSize(value: number, average: number): SectionSizeComparison {
  if (average <= 0) {
    return {
      value,
      average,
      percentDifference: null,
      tone: 'average',
      barRatio: value > 0 ? 1 : 0,
    };
  }

  const percentDifference = Math.round(((value - average) / average) * 100);
  let tone: SectionSizeComparisonTone = 'average';
  if (percentDifference > 5) {
    tone = 'above';
  } else if (percentDifference < -5) {
    tone = 'below';
  }

  const barRatio = Math.min(Math.max(value / average, 0), 2);

  return {
    value,
    average,
    percentDifference,
    tone,
    barRatio,
  };
}

export function formatSectionSizePercentLabel(percentDifference: number | null): string | null {
  if (percentDifference === null) {
    return null;
  }
  if (percentDifference === 0) {
    return 'avg';
  }
  const sign = percentDifference > 0 ? '+' : '';
  return `${sign}${percentDifference}%`;
}
